import { render } from "./RewardsView.vue?vue&type=template&id=03ece936&scoped=true"
const script = {}

import "./RewardsView.vue?vue&type=style&index=0&id=03ece936&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03ece936"]])

export default __exports__